import { render, staticRenderFns } from "./AdditionColleagues.vue?vue&type=template&id=3327c356&scoped=true"
import script from "./AdditionColleagues.vue?vue&type=script&lang=js"
export * from "./AdditionColleagues.vue?vue&type=script&lang=js"
import style0 from "./AdditionColleagues.vue?vue&type=style&index=0&id=3327c356&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3327c356",
  null
  
)

export default component.exports